import React from 'react';

function DepotStep({ number, title, children }) {
  return (
    <section className="depot-step">
      <div className="depot-step__head">
        <span className="depot-step__num" aria-hidden>{number}</span>
        <p className="depot-step__title mb-0">{title}</p>
      </div>
      <div className="depot-step__body">{children}</div>
    </section>
  );
}

export default DepotStep;
